module.exports = __webpack_public_path__ + "img/detail-card.67747fb5.svg";